import React from "react";
import { useLang } from "../contexts/LangContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Button } from "../components/ui/button";
import { Globe } from "lucide-react";

export default function LanguageSelector({ variant = "default" }) {
  const { lang, setLang, supported, flags, names } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="language-selector"
          variant="ghost"
          size="sm"
          className="gap-2 text-xs font-medium uppercase tracking-[0.14em]"
        >
          <Globe className="h-4 w-4" />
          <span>{flags[lang]} {lang.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {supported.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`language-option-${l}`}
            onClick={() => setLang(l)}
            className={l === lang ? "font-semibold" : ""}
          >
            <span className="mr-2">{flags[l]}</span>{names[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
